module.exports = __webpack_public_path__ + "img/ssyx_26.c890396c.jpg";